import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus, IdentityDocuments, VerificationType } from '../../types';
import { VerifyUserIcon, UserIcon } from '../../icons';
import { ProgressStatusCard } from '../../components';
import { AddressVerificationCard } from './AddressVerificationCard';
import { STATUS_ICONS_MAP } from './constants';
import './VerifyIdentityStep.scss';
export const VerifyIdentityStep = ({ userData, onStartVerification }) => {
    const { t } = useTranslation();
    const identityScenario = useMemo(() => {
        return userData && userData.scenarios
            ? userData.scenarios.find((scenario) => scenario.payload.verificationType === VerificationType.IDENTITY)
            : null;
    }, [userData]);
    if (!identityScenario) {
        return null;
    }
    const { scenarioType, status, payload } = identityScenario;
    const supportedDocuments = useMemo(() => payload.supportedDocuments, [payload]);
    const addressScenarios = useMemo(() => {
        return userData && userData.scenarios
            ? userData.scenarios.filter((scenario) => scenario.payload.verificationType === VerificationType.DOCUMENT)
            : null;
    }, [userData]);
    const handleStartVerification = () => {
        onStartVerification(scenarioType);
    };
    const isPendingState = status === DocumentStatus.REQUIRED || status === DocumentStatus.PENDING || status === DocumentStatus.NOT_UPLOADED;
    const isSubmittedState = status === DocumentStatus.SUBMITTED;
    return (React.createElement("div", { className: "verify-identity" },
        React.createElement("div", null,
            React.createElement(VerifyUserIcon, { width: 64, height: 64 })),
        React.createElement("h2", { className: "verify-identity__title" }, t('verify_identity_screen.title')),
        isPendingState ? (React.createElement("p", { className: "verify-identity__description" }, t('verify_identity_screen.description'))) : (React.createElement("p", { className: "verify-identity__description" }, t('verify_identity_screen.description_pending'))),
        React.createElement("div", { className: "verify-identity__inner-content" },
            React.createElement("div", { className: "verify-identity__inner-content__header" },
                React.createElement("div", { className: "verify-identity__inner-content__header__inner" },
                    React.createElement(UserIcon, { width: 24, height: 24 }),
                    React.createElement("p", null, t('verify_identity_screen.verify_your_identity'))),
                STATUS_ICONS_MAP.get(status)),
            React.createElement("p", { className: "verify-identity__inner-content__description" }, t('verify_identity_screen.verify_your_identity_description')),
            React.createElement("ul", { className: "verify-identity__inner-content__list" }, supportedDocuments.map((doc) => (React.createElement("li", { key: doc }, t(`common.${doc.toLowerCase()}`))))),
            isPendingState ? (React.createElement("button", { className: "verify-identity__inner-content__button", onClick: handleStartVerification }, t('verify_identity_screen.start_btn'))) : (React.createElement("div", { className: `verify-identity__inner-content__status verify-identity__inner-content__status--${status.toLowerCase()}` },
                React.createElement("span", { className: "verify-identity__inner-content__status__text" }, t(`verify_identity_screen.${status.toLowerCase()}`)))),
            isSubmittedState && React.createElement(ProgressStatusCard, null)),
        identityScenario && identityScenario.documentType === IdentityDocuments.PASSPORT && (React.createElement(React.Fragment, null, addressScenarios &&
            addressScenarios.map((addressScenario, index) => {
                const isDisabled = addressScenarios[index - 1]
                    ? addressScenarios[index - 1].status !== DocumentStatus.VERIFIED
                    : false;
                return (React.createElement(AddressVerificationCard, { key: addressScenario.scenarioType, addressScenario: addressScenario, count: index + 1, isDisabled: isDisabled, onChooseDocumentType: onStartVerification }));
            })))));
};
//# sourceMappingURL=VerifyIdentityStep.js.map